import { useFilterPanelContext } from "../../filter-panel.context";
import { resolveClearButton } from "../resolve-clear-button";
import type { FilterPanelMobileActionsViewProps } from "./types-mobile-actions";

/** ViewModel de Adicionar filtro + Limpar/Desfazer dentro do grupo de linhas do mobile (Figma "Filtro/Ações mobile"); sem JSX. */
export function useFilterPanelMobileActions(): FilterPanelMobileActionsViewProps {
  const panel = useFilterPanelContext();

  return { clearButton: panel.showClear ? resolveClearButton(panel) : null };
}
